import { render } from "./AdminSidebarElement.vue?vue&type=template&id=454a3ed8"
import script from "./AdminSidebarElement.vue?vue&type=script&lang=js"
export * from "./AdminSidebarElement.vue?vue&type=script&lang=js"

import "./AdminSidebarElement.vue?vue&type=style&index=0&id=454a3ed8&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__